import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import BlockFloatingOptions from "@/content-hub/editor/floating-options/block-floating-options";
import Image from "@/content-hub/theme/primitives/image/image-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/content-hub/theme/shared/block-wrapper";

import { ImageAndTextWithButtonTwoColumnsSettings } from "./image-and-text-with-button-two-columns-settings";
import TextWithButton from "./text-with-button";

interface Props {
  showCTA?: boolean;
  defaultImage?: string;
}

const StyledContentContainer = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(120)};
  position: relative;

  ${(props) => props.$viewport.tablet`
    gap: ${rem(24)};
    grid-template-columns: 1fr;
  `}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: auto; 
  `}

  .image-primitive {
    max-width: ${rem(512)};
    margin: auto;
    position: relative;
    ${(props) => props.$viewport.tablet`
      max-width: 100%;
    `}
  }
`;

export default function ImageAndTextWithButtonTwoColumns({
  showCTA = false,
  defaultImage = "/canvas/hazel/images/rce-default-animation.gif",
}: Props) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper
      ref={connect}
      id={nodeId}
      data-testid="paragraph-picture"
    >
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <StyledContentContainer>
            <Element
              id="text-with-image-image"
              is={Image}
              defaultSrc={defaultImage}
            />
            <TextWithButton showCTA={showCTA} />
          </StyledContentContainer>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

ImageAndTextWithButtonTwoColumns.craft = {
  isCanvas: false,
  custom: {
    displayName: "Image and text with button in two columns",
    settingsTitle: "selection-menu.selection.blocks.paragraph-picture",
  },
  related: {
    leftOutlineOptions: BlockFloatingOptions,
    settings: ImageAndTextWithButtonTwoColumnsSettings,
  },
};
